import { Empty } from '@flex-design-system/fx';
import { ExclamationmarkSquareIcon } from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';
import type { ReactNode } from 'react';

interface Props {
  title: ReactNode;
}

export function ClosedPageLayout({ title }: Props) {
  return (
    <PageWrapper>
      <Empty
        size="large"
        topSlot={<ExclamationmarkSquareIcon color="blackAlpha012" />}
        title={<Empty.Title>{title}</Empty.Title>}
      />
    </PageWrapper>
  );
}

const PageWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: '80px 16px',

  backgroundColor: '$white',
});
